import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "../../ConfirmationModal"
import { DocumentTemplate } from "../../../models/ConsentDocument";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        template?: DocumentTemplate;
    };
    onClose: () => void;
    deleteTemplate: (template: DocumentTemplate) => void
}

export const DeleteAgencyDocusignTemplate: React.FC<Props> = ({
    info,
    onClose,
    deleteTemplate
}) => {
    const { t } = useTranslation();

    const onDeleteTemplate = () => {
        deleteTemplate(info.template!)
        onClose();
    };
    
    return(
        <ConfirmationModal 
            label={t("DELETE_TEMPLATE")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteTemplate }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_DOCUSIGN_TEMPLATE_MESSAGE', {label: info.template?.name})}
                </label>
            </div>
        </ConfirmationModal>
    )
}